module.exports = __webpack_public_path__ + "static/media/RP-B_S_Fashion_Sempione.2ca8db23.png";